<template>
<div class="chapter">
<div class="inner_page">
<p class="img"><img alt="Image" src="images/dot.jpg" style="max-width:100%;"/></p>
<p class="fmcenter1">CONTENTS</p>
<p class="toc"><a class="htt" href="#/xhtml/introduction">Introduction</a></p>
<p class="toc1"><a class="htt" href="#/xhtml/ch01">CHAPTER 1: FOR THE SMART FoODIE IN yOU</a></p>
<p class="toc3"><a class="htt" href="#/xhtml/ch01#ch_1">Nutritional Boost: Vitamins</a></p>
<p class="toc2"><a class="htt" href="#/xhtml/ch01#ch_2">Nutritional Boost: Minerals</a></p>
<p class="toc2"><a class="htt" href="#/xhtml/ch01#ch_3">Nutritional Boost: Flavor Notes</a></p>
<p class="toc1"><span class="htt" href="#/xhtml/ch02" title="Link target outside of Sample">CHAPTER 2: FOR THE HEALTH ENTHUSIAST IN YoU</span></p>
<p class="toc3"><span class="htt" href="#/xhtml/ch02#ch2_1" title="Link target outside of Sample">Managing Disease</span></p>
<p class="toc2"><span class="htt" href="#/xhtml/ch02#ch2_2" title="Link target outside of Sample">Managing Symptoms</span></p>
<p class="toc2"><span class="htt" href="#/xhtml/ch02#ch2_3" title="Link target outside of Sample">Managing Well-Being</span></p>
<p class="toc1"><span class="htt" href="#/xhtml/ch03" title="Link target outside of Sample">CHAPTER 3: FOR THE CoSMETICiAN IN YoU</span></p>
<p class="toc3"><span class="htt" href="#/xhtml/ch03#ch3_1" title="Link target outside of Sample">Beautiful Skin</span></p>
<p class="toc2"><span class="htt" href="#/xhtml/ch03#ch3_2" title="Link target outside of Sample">Gorgeous Hair</span></p>
<p class="toc2"><span class="htt" href="#/xhtml/ch03#ch3_3" title="Link target outside of Sample">Stunning Nails</span></p>
<p class="toca"><span class="htt" href="#/xhtml/notes" title="Link target outside of Sample">Notes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?37a5df6a